import React, { useEffect } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CBU34thGraduation = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Sponsors Best Graduating Students at CBU 34th Graduation</h1>

                    <p className="pb-3">Indo Zambia Bank is proud to have sponsored the Best Graduating Students in the School of Business at The Copperbelt University 34th Graduation and Convocation Ceremony, held on 23rd and 24th April 2026 at the Riverside Main Campus in Kitwe.</p>

                    <p className="pb-3">We celebrate excellence and outstanding academic achievement demonstrated by the following graduates:</p>

                    <ul className="pb-3" style={{ paddingLeft: "1.5rem" }}>
                        <li className="pb-2"><strong>Bachelor of Accountancy</strong> – Komani Fred Nyirenda (Distinction)</li>
                        <li className="pb-2"><strong>Bachelor of Business Administration</strong> – Grace Kangwa (Distinction)</li>
                        <li className="pb-2"><strong>Bachelor of Science in Banking &amp; Finance</strong> – Thandiwe Phiri (Distinction)</li>
                        <li className="pb-2"><strong>Bachelor of Science in Marketing</strong> – Memory Mutobo (Merit)</li>
                        <li className="pb-2"><strong>Bachelor of Science in Purchasing and Supply Chain Management</strong> – Edison Ndemba (Distinction)</li>
                    </ul>

                    <p className="pb-3">We remain committed to supporting the communities we serve by investing in education, nurturing future leaders, and empowering growth that transforms potential into impact.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #CBU #CopperbeltUniversity #Graduation #Education #Excellence</em></b></p>

                    <h2 className="pt-5 pb-4 text-left">Gallery</h2>
                    <Slider {...settings}>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.19%20PM.jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.18%20PM.jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.18%20PM%20(1).jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.17%20PM.jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.17%20PM%20(1).jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.16%20PM.jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.16%20PM%20(1).jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp%20Image%202026-04-24%20at%208.24.14%20PM.jpeg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                    </Slider>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default CBU34thGraduation;
